import type { Tagged } from 'type-fest'

export type NodeId = Tagged<string, 'NodeId'>

export function generateNodeId() {
  return (
    Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
  ).toLowerCase() as NodeId
}
